module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('profile')))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.setImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "cropper-area"
  }, [_c('div', {
    staticClass: "img-cropper"
  }, [_c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "aspect-ratio": 16 / 16,
      "src": _vm.imgSrc,
      "preview": ".preview"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showFileChooser($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v("\n          Upload Image\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.zoom(0.2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  }), _vm._v("\n          Zoom In\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.zoom(-0.2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search-minus"
  }), _vm._v("\n          Zoom Out\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.rotate(90)
      }
    }
  }, [_vm._v("\n          Rotate +90deg\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.rotate(-90)
      }
    }
  }, [_vm._v("\n          Rotate -90deg\n        ")]), _vm._v(" "), _c('a', {
    ref: "flipX",
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.flipX($event)
      }
    }
  }, [_vm._v("\n          Flip X\n        ")]), _vm._v(" "), _c('a', {
    ref: "flipY",
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.flipY($event)
      }
    }
  }, [_vm._v("\n          Flip Y\n        ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "background": "#ff0000"
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cropImage($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-crop"
  }), _vm._v("\n          Crop\n        ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "background": "#1fad45"
    },
    attrs: {
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.upload($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("\n          Save\n        ")])])]), _vm._v(" "), _c('section', {
    staticClass: "preview-area"
  }, [_c('p', [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }), _vm._v(" "), _c('p', [_vm._v("Cropped Image")]), _vm._v(" "), _c('div', {
    staticClass: "cropped-image"
  }, [(_vm.cropImg) ? _c('img', {
    attrs: {
      "src": _vm.cropImg,
      "alt": "Cropped Image"
    }
  }) : _c('div', {
    staticClass: "crop-placeholder"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ae53f32!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Profile.vue
// module id = 738
// module chunks = 1